class ErrorMessage {
    public Message:string = ''

    constructor(msg: string) {
        this.Message = msg;
    }
}

export default ErrorMessage;